import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from 'Common/CustomButtons/Button';
import Lightbox from 'Components/Lightbox/Lightbox';
import { FormattedMessage } from 'react-intl';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import { reduxForm } from 'redux-form';

@reduxForm({
    form: 'lightboxForm',
    enableReinitialize: true,
})
export default class ButtonLightbox extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        children: PropTypes.node,
        openBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        openBtnColor: PropTypes.string,
        openBtnRight: PropTypes.bool,
        openBtnDisabled: PropTypes.bool,
        customClass: PropTypes.string,
        handleClickOpen: PropTypes.func,
        handleSubmit: PropTypes.func,
        handleClose: PropTypes.func,
        submitDisabled: PropTypes.bool,
        submitBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        skipBtn: PropTypes.bool,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        openBtnColor: 'primary',
        openBtnRight: false,
        skipBtn: false
    };

    render() {
        const { children, handleClickOpen, openBtnColor, openBtnText, openBtnRight, openBtnDisabled, skipBtn,
            handleSubmit, handleClose, submitDisabled, submitBtnText, ...extraArgs } = this.props;

        return (
            <div className='button-lightbox-wrapper'>
                <Button
                    onClick={handleClickOpen}
                    color={openBtnColor}
                    right={openBtnRight}
                    disabled={openBtnDisabled}
                >
                    {openBtnText}
                </Button>

                <Lightbox
                    handleClose={handleClose}
                    dialogActions={false}
                    {...extraArgs}
                >
                    <form
                        onSubmit={handleSubmit}
                        id="submission.data"
                    >
                        {children}
                        <DialogActions className='emails-dialog-wrapper'>
                            <Button type="submit" color="success" disabled={submitDisabled} right customClass='lightbox-submit-btn'>
                                {submitBtnText}
                            </Button>

                            {skipBtn && <Button type="button" onClick={e => handleSubmit(e, true)} customClass='lightbox-submit-skip-btn upload-style-btn' right>
                                <FormattedMessage id={'button.lightbox.skip'} />
                            </Button>}

                            <Button onClick={handleClose} color="danger" customClass='lightbox-submit-cancel-btn' right>
                                <FormattedMessage id={'button.lightbox.cancel'} />
                            </Button>
                        </DialogActions>
                    </form>
                </Lightbox>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ButtonLightbox/ButtonLightbox.jsx